export default "__VITE_ASSET__ltK7vRtu__"